// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".___test___style__label{background-color:#000;margin:0;padding:0}.___test___style{font-size:26px;padding:0;background-color:#ff0;border:red}.el-table .warning-row{background:#fdf5e6}.el-table .success-row{background:#f0f9eb}", ""]);
// Exports
module.exports = exports;
